<template>
	<v-card
		class="overview-card"
		:class="{ 'grey lighten-5': useGrey }"
		max-width="500"
		width="100%"
		flat
		@click="$emit('overview')"
	>
		<div class="card-content">
			<div class="card-icon-wrapper">
				<v-icon
					color="primary"
					size="28"
				>
					{{ icon }}
				</v-icon>
			</div>

			<h3 class="card-title">
				{{ title }}
			</h3>

			<p
				v-if="description"
				class="card-description"
			>
				{{ description }}
			</p>

			<!-- Optional area for custom content like toggles, status, etc. -->
			<div
				v-if="$slots.extra"
				class="card-extra"
				@click.stop
			>
				<slot name="extra" />
			</div>

			<div class="card-actions">
				<v-icon
					size="18"
					color="grey"
					class="ml-1"
				>
					mdi-chevron-right
				</v-icon>
			</div>
		</div>
	</v-card>
</template>

<script>
export default {
	name: 'overview-card',
	props: {
		title: {
			type: String,
			required: true
		},
		description: {
			type: String
		},
		icon: {
			type: String,
			default: 'mdi-view-dashboard'
		},
		useGrey: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss" scoped>
.overview-card {
	position: relative;
	border-radius: var(--radius, 8px) !important;
	border: 1px solid var(--global-border-color, #e5e7eb) !important;
	border-left: 4px solid var(--global-primary, #406A94) !important;
	background-color: var(--global-card-background, #ffffff) !important;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
	}
}

.card-content {
	padding: 20px;
	display: flex;
	flex-direction: column;
	min-height: 160px;
}

.card-icon-wrapper {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 48px;
	height: 48px;
	background-color: var(--global-muted, #f3f4f6);
	border-radius: var(--radius, 8px);
	margin-bottom: 16px;
}

.card-title {
	font-family: 'Inter', sans-serif;
	font-size: 0.875rem;
	font-weight: 600;
	color: var(--global-header-text-color, #1f2937);
	margin: 0 0 8px 0;
	line-height: 1.4;
}

.card-description {
	font-family: 'Inter', sans-serif;
	font-size: 0.75rem;
	font-weight: 400;
	color: var(--global-muted-foreground, #6b7280);
	margin: 0;
	line-height: 1.5;
	flex-grow: 1;
}

.card-extra {
	margin-top: 12px;
}

.card-actions {
	position: absolute;
	bottom: 16px;
	right: 16px;
	display: flex;
	align-items: center;
	gap: 2px;
}

</style>

<!-- Unscoped styles for Vuetify v-card overrides -->
<style lang="scss">
.v-card.overview-card {
	border: 1px solid var(--global-border-color, #e5e7eb) !important;
	border-left: 4px solid var(--global-primary, #406A94) !important;
	background-color: var(--global-card-background, #ffffff) !important;
}

.dark .v-card.overview-card,
.theme--dark .v-card.overview-card {
	background-color: var(--global-card-background, #1c1c1e) !important;
	border-top: 1px solid var(--global-border-color, #2e2e32) !important;
	border-right: 1px solid var(--global-border-color, #2e2e32) !important;
	border-bottom: 1px solid var(--global-border-color, #2e2e32) !important;
	border-left-width: 4px !important;
	border-left-style: solid !important;
	border-left-color: var(--global-primary, #ed303e) !important;
}

.dark .overview-card .card-icon-wrapper,
.theme--dark .overview-card .card-icon-wrapper {
	background-color: rgba(255, 255, 255, 0.08);
}

.dark .overview-card .card-title,
.theme--dark .overview-card .card-title {
	color: var(--global-foreground, #f5f5f5);
}

.dark .overview-card .card-description,
.theme--dark .overview-card .card-description {
	color: var(--global-muted-foreground, #9ca3af);
}
</style>
